import React from 'react';
import { Field } from 'formik';
import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';
import Select from "components/Form/Select";
const GeneralForm = ({centers}) => (
	<div>
        <Field
			type='text'
			name='label'
			customlabel='Nom'
			component={CustomInputTextComponent}
			required
		/>
		<Field
			type='text'
			name='tid'
			customlabel='Id du terminal'
			component={CustomInputTextComponent}
			required
		/>
		<Field
			type='text'
			name='ip'
			customlabel='Adresse IP'
			component={CustomInputTextComponent}
			required
		/>
		<Field
			customlabel='Port'
			type='number'
			name='port'
			component={CustomInputTextComponent}
			required
		/>
		 <Field
			component={Select}
			name="center.id"
			customlabel="Centre"
			placeholder=''
			options={centers}
		/>
	</div>
);

export default GeneralForm;
